import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import Logger from '../../lib/Logger';
// import { axiosVBGetCall } from '../../../services/vbApiCall';
import { renderErrorMessage } from '../../lib/toastMessage';
import { mainResselerId } from 'src/lib/Enums';
// import { TtsPlanTable } from './ttsPlanTable';
import { UserPlanTable } from './userPlanTable';
import { ResellerPlanTable } from './wpapiresellerPlanTable';
import { axiosGetCall } from 'src/services/apisCall';
import { AmountPlanTable } from './amountPlanTable';
import { type } from '@testing-library/user-event/dist/type';
const logger = new Logger('userPlansModal');

const whatsappPlans = ({ user }) => {
  const [credits, setCredits] = useState([]);
  const [assignedPlan, setAssignedPlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState([]);

  const getUserUpdatedCredit = async () => {
    try {
      const params = { skip: '0', limit: '100' };
      const { data } = await axiosGetCall('CAGetPlanNCredits', { userId: user?.userId, type: 'user' });
      setAssignedPlan(data);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
  };
  const getCredits = async () => {
    try {
      let data;
      if (user?.userId === mainResselerId) {
        data = await axiosGetCall('GetAllPlansCreditAmount', {});
      } else {
        data = await axiosGetCall('CAGetPlanNCredits', { userId: mainResselerId });
      }

      setCredits(data?.data);
    } catch (error) {
      logger.error('getCredits', error);
      renderErrorMessage(error?.message);
    }
  };

  const getAmount = async () => {
    try {
      const { data } = await axiosGetCall('getUserBalance', { userId: user?.voiceInfo?.userId });
      const arr = [
        {
          Validity: data.Validity,
          currentAmount: data.currentAmount,
          reservedAmount: data.reservedAmount,
          totalAmount: data.totalAmount,
        },
      ];
      setAmount(arr);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
  };

  const forceLoad = async () => {
    setLoading(true);
    await getUserUpdatedCredit();
    await getCredits();
    await getAmount();
    setLoading(false);
  };

  useEffect(() => {
    forceLoad();
    //eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        width: '855px',
        overflow: 'hidden',
        height: 'calc(70vh)',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
      }}
    >
      {/* <Heading>
                TTS Plan
            </Heading> */}
      <AmountPlanTable amount={amount} user={user} forceLoad={forceLoad} loading={loading} />

      {/* <Heading>
                Currrent Assign Plan
            </Heading> */}
      <UserPlanTable planWiseCredits={assignedPlan} user={user} forceLoad={forceLoad} loading={loading} />

      {/* <Heading>
                Reseller login Plans
            </Heading> */}
      <ResellerPlanTable
        credits={credits}
        assignedPlan={assignedPlan}
        user={user}
        forceLoad={forceLoad}
        loading={loading}
      />
    </Box>
  );
};

export default whatsappPlans;
